export const SITE_NAME = 'CNA Classes For Me';
